export enum SmartFilterType {
  Normal,
  Claim,
}
